import { render, staticRenderFns } from "./DataReportShortCourse.vue?vue&type=template&id=47899c56"
import script from "./DataReportShortCourse.vue?vue&type=script&lang=js"
export * from "./DataReportShortCourse.vue?vue&type=script&lang=js"
import style0 from "./DataReportShortCourse.vue?vue&type=style&index=0&id=47899c56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports